import React from "react";

function LazyLoader() {
  return <div></div>;
}

export default LazyLoader;
